export async function responseError(err, message) {
    let resp = {
        error: true,
        message: ""
    }
    if (err.response) {
        console.error(err.response);
        let status = err.response.status;
        if (status==401 || status==400) {
            resp.message = err.response.data.mensaje;
        } else {
            resp.message = message;
        }
        //develver error segun estado
    } else {
        resp.message = "Hubo un error al intentar conectar con el servidor.";
        //develver error de red
    }
    return resp;
}